<template>
  <div class="container">
    <div class="page-title">
      <div class="decoration-lefttop"></div>
      <div class="title-wrap">
        <div class="title">公证书验证结果</div>
        <div class="subtitle">RESULT</div>
      </div>
      <div class="decoration-righttop"></div>
    </div>
    <div class="content-bg">
      <div class="filename" v-if="fileName">{{ fileName }}</div>
      <!-- 验证不通过 -->
      <div class="status" v-if="!caseInfo">
        <div>
          <close-one
            theme="multi-color"
            size="64"
            :fill="['#383838', '#f5222d', '#FFF', '#f5222d']"
            :strokeWidth="2"
            strokeLinecap="butt"
          />
        </div>
        <div class="status-title">验证不通过</div>
        <div class="help-tip">
          请注意！该份文件非上海智慧公证一体化办证平台出具，请仔细辨别，谨防伪造
        </div>
      </div>
      <!-- 核验通过 -->
      <div
        class="status"
        v-else-if="caseInfo.properties.progress === 'COMPLETED'"
      >
        <check-one
          theme="multi-color"
          size="64"
          :fill="['#383838', '#4d6de3', '#FFF', '#4d6de3']"
          :strokeWidth="2"
          strokeLinecap="butt"
        />
        <div class="status-title">验证通过</div>
        <div class="hash-code">
          {{ caseInfo | display("fingerprint") | splitByLength(4) }}（哈希值）
        </div>
        <div class="help-tip">
          该份电子公证书确由上海智慧公证一体化办证平台出具，文书及材料附件内容真实、有效且未被篡改
        </div>
      </div>
      <!-- 作废 -->
      <div
        class="status"
        v-else-if="caseInfo.properties.progress === 'DISCARD'"
      >
        <abnormal
          theme="multi-color"
          size="64"
          :fill="['#383838', '#f5222d', '#FFF', '#f5222d']"
          :strokeWidth="2"
          strokeLinecap="butt"
        />
        <div class="status-title">已作废</div>
        <div class="hash-code">
          {{ caseInfo | display("fingerprint") | splitByLength(4) }}（哈希值）
        </div>
        <div class="help-tip">
          该份电子公证书确由上海智慧公证一体化办证平台出具，但已被公证机构标记作废，详询承办公证员
        </div>
      </div>
      <div class="info-list">
        <!-- 公证书基本信息 -->
        <div class="info-item">
          <div class="title-wrap">
            <div class="title">公证书基本信息</div>
            <div class="decoration-line"></div>
          </div>
          <template v-if="caseInfo">
            <div class="descriptions-row">
              <div class="descriptions-label">公证书编号</div>
              <div class="descriptions-content">
                {{ caseInfo | display("caseNumber") }}
              </div>
            </div>
            <div class="descriptions-row">
              <div class="descriptions-label">公证事项</div>
              <div class="descriptions-content">
                {{ caseInfo | display("caseTypeNames") }}
              </div>
            </div>
            <div class="descriptions-row">
              <div class="descriptions-label">出证日期</div>
              <div class="descriptions-content">
                {{ caseInfo | display("makeDate") | chineseDate }}
              </div>
            </div>
            <div class="descriptions-row">
              <div class="descriptions-label">公证机构</div>
              <div class="descriptions-content">
                {{ caseInfo | display("notaryOffice") }}
              </div>
            </div>
            <div class="descriptions-row">
              <div class="descriptions-label">公&nbsp;证&nbsp;员</div>
              <div class="descriptions-content">
                {{ caseInfo | display("notary") }}
              </div>
            </div>
          </template>
          <!-- 无公证书信息 -->
          <div v-else class="not-found-wrap">
            <div class="icon icon-1"></div>
            <div class="desc">未找到公证书信息</div>
          </div>
        </div>
        <!-- 电子签名 -->
        <div class="info-item">
          <div class="title-wrap">
            <div class="title">电子签名信息</div>
            <div class="decoration-line"></div>
          </div>
          <template v-if="signatureList.length">
            <template v-for="item in signatureList">
              <div class="signature-item" :key="item.signature">
                <div class="tips">由“{{ item.commonName }}”签名</div>
                <div class="descriptions-row">
                  <div class="descriptions-label">签名有效</div>
                  <div class="descriptions-content">
                    自应用本签名以来，“文档”未被修改
                  </div>
                </div>
                <div class="descriptions-row">
                  <div class="descriptions-label">签名时间</div>
                  <div class="descriptions-content">
                    {{ item.signDat | fullDate }}
                  </div>
                </div>
                <div class="descriptions-row">
                  <div class="descriptions-label">原&nbsp;&nbsp;因</div>
                  <div class="descriptions-content">{{ item.reason }}</div>
                </div>
                <div class="descriptions-row">
                  <div class="descriptions-label">时&nbsp;间&nbsp;戳</div>
                  <div class="descriptions-content">
                    {{ item.signDat | fullDate }}
                  </div>
                </div>
              </div>
            </template>
          </template>
          <!-- 无公证书信息 -->
          <div v-else class="not-found-wrap">
            <div class="icon icon-2"></div>
            <div class="desc">无电子签名信息</div>
          </div>
        </div>
      </div>
      <!-- 有效性小节 -->
      <div class="tips-block" v-if="signatureList.length">
        <div>有效性小结：</div>
        <div>1.符合《电子签名法》第十三条中可靠电子签名的规定</div>
        <div>2.自签名人签署后，电子签名未被更改</div>
        <div>3.自签名人签署后，由电子签名保护的文档内容未被更改</div>
      </div>
      <div class="btn" @click="back()">
        <left-small theme="outline" size="20" fill="#333" />返回上一页
      </div>
    </div>
  </div>
</template>

<script>
import { CloseOne, CheckOne, Abnormal, LeftSmall } from "@icon-park/vue";
export default {
  components: {
    CloseOne,
    CheckOne,
    Abnormal,
    LeftSmall,
  },
  data: function () {
    return {
      result: undefined,
      caseInfo: undefined,
      signatureList: [],
      fileName: undefined,
    };
  },
  created() {
    const json = sessionStorage.getItem("checkResult");
    this.fileName = sessionStorage.getItem("fileName");
    if (json) {
      this.result = JSON.parse(json);
      this.caseInfo = this.result.case;
      this.signatureList = this.result.signatureList || [];
    }
    sessionStorage.removeItem("checkResult");
    sessionStorage.removeItem("fileName");
  },
  methods: {
    back() {
      this.$router.back();
    },
  },
};
</script>

<style lang="scss" scoped>
.page-title {
  margin-top: 24px;
  position: relative;
  display: flex;
  .decoration-lefttop {
    width: 80px;
    height: 80px;
    background: url("../assets/images/square_decoration.svg") bottom left
      no-repeat;
    background-size: contain;
    pointer-events: none;
    opacity: 0.15;
  }
  .title-wrap {
    padding-left: 16px;
    padding-top: 16px;
    display: flex;
    flex-direction: column;
  }
  .title {
    font-size: 24px;
  }
  .subtitle {
    padding-top: 8px;
    font-size: 18px;
    font-weight: lighter;
    color: rgba($color: #000000, $alpha: 0.65);
  }
  .decoration-righttop {
    position: absolute;
    right: 24px;
    top: -4px;
    width: 120px;
    height: 155px;
    background-image: url("../assets/images/decoration_3.png");
    background-size: contain;
    pointer-events: none;
  }
}

.content-bg {
  overflow: hidden;
  margin-top: 20px;
  padding-bottom: 40px;
  border-radius: 10px 10px 0 0;
  border: 1px solid rgba(255, 255, 255, 1);
  background-color: #fff;
  box-shadow: 0 -3px 5px rgba($color: #000000, $alpha: 0.05);
  .filename {
    padding: 0 32px;
    height: 48px;
    line-height: 48px;
    text-align: center;
    font-size: 18px;
    font-weight: 500;
    // border-bottom: 1px solid rgba($color: #000000, $alpha: 0.08);
    background-color: #e4e9fb;
  }
  .status {
    position: relative;
    padding: 32px 0;
    text-align: center;
    &::after {
      content: "";
      display: block;
      position: absolute;
      left: 50%;
      bottom: 0;
      margin-left: -20px;
      width: 36px;
      height: 4px;
      background-color: #383838;
    }
  }
  .icon {
    margin: 0 auto;
  }
  .status-title {
    margin-top: 18px;
    font-size: 24px;
    font-weight: 700;
    color: #383838;
  }
  .hash-code {
    margin-top: 15px;
    font-size: 16px;
    color: rgba($color: #000000, $alpha: 0.85);
  }
  .help-tip {
    margin-top: 16px;
    font-size: 16px;
    font-weight: 300;
    color: #383838;
  }
  .info-list {
    margin: 48px auto 0;
    width: 800px;
    .info-item + .info-item {
      margin-top: 30px;
    }
    .title-wrap {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-bottom: 8px;
    }
    .title {
      padding-right: 16px;
      font-size: 16px;
      font-weight: bold;
      color: rgba($color: #000000, $alpha: 0.85);
    }
    .decoration-line {
      flex: 1;
      height: 0.5px;
      background-color: rgba(0, 0, 0, 0.08);
    }
    .descriptions-row {
      margin-top: 20px;
      display: flex;
      color: #383838;
      font-size: 14px;
    }
    .descriptions-label {
      width: 90px;
      &::after {
        content: "：";
      }
    }
    .tips {
      margin-top: 20px;
      font-size: 14px;
      font-weight: bold;
    }
  }
  .tips-block {
    margin: 30px auto 0;
    width: 800px;
    padding: 10px 15px;
    line-height: 24px;
    font-size: 14px;
    color: #383838;
    border: 1px solid #b7eb8f;
    background-color: #f6ffed;
    border-radius: 8px;
  }
  .btn {
    margin: 40px auto 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 140px;
    height: 40px;
    color: #383838;
    font-size: 14px;
    border: 1px solid rgba($color: #000000, $alpha: 0.15);
    border-radius: 20px;
    cursor: pointer;
    span {
      margin-top: 2px;
      margin-right: 4px;
    }
    &:hover {
      border-color: #4d6de3;
    }
  }

  .signature-item + .signature-item {
    margin-top: 20px;
  }
}

.not-found-wrap {
  margin: 0 auto;
  padding: 30px 0;
  .icon {
    width: 200px;
    height: 150px;
    background-size: contain;
    &.icon-1 {
      background-image: url("~@/assets/images/not-found-1.png");
    }
    &.icon-2 {
      background-image: url("~@/assets/images/not-found-2.png");
    }
  }
  .desc {
    text-align: center;
    font-size: 14px;
    color: rgba($color: #000000, $alpha: 0.35);
  }
}
</style>